import { Visit } from '@dreryk/egabinet-visit-frontend-api';

import { Scroll } from '@dreryk/react-components';

import { ReferralToPsychiatricHospitalForm } from './ReferralToPsychiatricHospitalForm/ReferralToPsychiatricHospitalForm';
import { ReferralToPsychiatricHospitalPanelLoader } from './ReferralToPsychiatricHospitalPanel.loader';
import { ReferralToPsychiatricHospitalRouteLeavingGuard } from './ReferralToPsychiatricHospitalRouteLeavingGuard';
import { ReferralToPsychiatricHospitalSendAction } from './ReferralToPsychiatricHospitalSendAction/ReferralToPsychiatricHospitalSendAction';

type ReferralToPsychiatricHospitalPanelProps = {
   readonly visit: Visit;
};

export const ReferralToPsychiatricHospitalPanel = (props: ReferralToPsychiatricHospitalPanelProps): JSX.Element => {
   return (
      <Scroll testId={'referralToPsychiatricHospital'}>
         <ReferralToPsychiatricHospitalPanelLoader visitId={props.visit.id}>
            {({ referralToPsychiatricHospitalDraft }) => (
               <ReferralToPsychiatricHospitalForm
                  referralToPsychiatricHospitalDraft={referralToPsychiatricHospitalDraft}
                  visitDiagnoses={props.visit.diagnoses}
                  visitBeginDate={props.visit.beginDate}
                  patientId={props.visit.patient.id}
               >
                  {({ handleSubmit, handleSubmitDraft, formState, reset }) => (
                     <>
                        <ReferralToPsychiatricHospitalSendAction
                           visitId={props.visit.id}
                           handleSubmit={handleSubmit}
                           onSuccess={reset}
                        />
                        <ReferralToPsychiatricHospitalRouteLeavingGuard
                           formState={formState}
                           visitId={props.visit.id}
                           handleSubmitDraft={handleSubmitDraft}
                        />
                     </>
                  )}
               </ReferralToPsychiatricHospitalForm>
            )}
         </ReferralToPsychiatricHospitalPanelLoader>
      </Scroll>
   );
};
